const en = {
	appName: 'resolvo.me',
	welcomeMessage: 'Manage and Track Your New Year Resolutions',
	signInToYourAccount: 'Sign in to your account',
	createYourAccount: 'Create your account',
	firstName: 'First Name',
	lastName: 'Last Name',
	emailAddress: 'Email Address',
	password: 'Password',
	confirmPassword: 'Confirm Password',
	signUp: 'Sign Up',
	signIn: 'Sign In',
	processing: 'Processing...',
	dontHaveAccountSignUp: "Don't have an account? Sign up",
	alreadyHaveAccountSignIn: 'Already have an account? Sign in',
	resetPassword: 'Reset Password',
	sendResetEmail: 'Send Reset Email',
	sending: 'Sending...',
	rememberMe: 'Remember Me',
	forgotPassword: 'Forgot password?',
	adminDashboard: 'Admin Dashboard',
	myDashboard: 'My Dashboard',
	myProfile: 'My Profile',
	settings: 'Settings',
	signOut: 'Sign Out',
	addResolution: 'Add Resolution',
	cancel: 'Cancel',
	makePrivate: 'Make this resolution private (encrypted)',
	encryptionKey: 'Encryption Key',
	enterEncryptionKey: 'Enter a secure key to encrypt your resolution',
	rememberEncryptionKey: "Remember this key! - you'll need it to view your private resolution",
	type: 'Type',
	year: 'Year',
	resolutionText: 'Resolution Text',
	exampleCount: 'e.g., Read 20 books this year',
	exampleBinary: 'e.g., Buy a new car',
	exampleMetric: 'e.g., Lose 10 kg by year end',
	startValue: 'Start Value',
	targetValue: 'Target Value',
	unit: 'Unit',
	unitExample: 'e.g., kg, km, hours, USD',
	exampleStreak: 'e.g., Drink 2 L of water every day (log daily)',
	currentStreak: 'Current Streak',
	longestStreak: 'Longest Streak',
	never: 'Never',
	measurements: 'Measurements',
	lastLogDate: 'Last log date',
	daysInARow: 'days in a row',
	dailyInARow: 'days in a row',
	weeklyInARow: 'weeks in a row',
	monthlyInARow: 'months in a row',
	period: 'Period',
	daily: 'Daily',
	weekly: 'Weekly',
	monthly: 'Monthly',
	value: 'Value',
	note: 'Note',
	add: 'Add',
	loading: 'Loading...',
	resolutions: 'Resolutions',
	claimAccount: 'You should claim your account to add resolutions',
	timeUntilNewYear: 'Time Until New Year',
	contactAdmin: 'Contact admin for your resolutions...',
	verifyingLink: 'Verifying your link...',
	invalidLink: 'Invalid Link',
	goToLogin: 'Go to Login',
	completeAccountClaim: 'Complete Account Claim',
	emailVerifiedCreatePassword: 'Email verified! Create a password to secure your account.',
	accountLabel: 'Account',
	createPasswordLabel: 'Create Password',
	confirmPasswordLabel: 'Confirm Password',
	enterYourPassword: 'Enter your password',
	confirmYourPassword: 'Confirm your password',
	creatingAccount: 'Creating Account...',
	completeClaim: 'Complete Claim',
	backToLogin: 'Back to Login',
	passwordMismatch: 'Passwords do not match',
	passwordTooShort: 'Password must be at least 6 characters',
	invalidOrExpiredLink: 'Invalid or expired verification link',
	linkNotFound: 'Verification link not found or has expired',
	linkExpiredRequestNew: 'Verification link has expired. Please request a new one.',
	accountAlreadyClaimed: 'This account has already been claimed',
	failedToCreateAccount: 'Failed to create account. Please try again.',
	claimErrorGeneric: 'An error occurred while completing the claim',
	resolution: 'resolution',
	total: 'total',
	overallProgress: 'Overall Progress',
	progress: 'Progress',
	completed: 'Completed',
	complete: 'Complete',
	'waiting-completion': 'Waiting for completion',
	ahead: 'Ahead',
	behind: 'Behind',
	'on-track': 'On Track',
	failed: 'Failed',
	private: 'Private',
	decrypt: 'Decrypt',
	delete: 'Delete',
	backToPlrofile: '← Back to Profile',
	customizeProfile: 'Customize your profile and preferences',
	displayNameHeading: 'Display Name',
	displayNameHelp: 'How your name appears on your profile',
	enterDisplayName: 'Enter your display name',
	currentlyShowing: 'Currently showing',
	emailPreferences: 'Email Preferences',
	requiredForReceiving: 'Required for receiving email notifications',
	weeklyStatusEmail: 'Weekly Status Email',
	emailRequired: '(Email address required)',
	timerStyle: 'Timer Style',
	chooseTimer: 'Choose how you want your countdown timer to appear',
	selected: 'Selected',
	preview: 'Preview:',
	saving: 'Saving...',
	saveSettings: 'Save Settings',
	count: 'Count',
	binary: 'Yes/No',
	metric: 'Metric Change',
	streak: 'Streak',
	yes: 'Yes',
	no: 'No',
	'timer.months': 'Months',
	'timer.days': 'Days',
	'timer.hours': 'Hours',
	'timer.minutes': 'Minutes',
	'timer.seconds': 'Seconds',
	'timer.monthsShort': 'MO',
	'timer.daysShort': 'D',
	'timer.hoursShort': 'HRS',
	'timer.minutesShort': 'MIN',
	'timer.secondsShort': 'SEC',
	'timer.monthsShortLower': 'mo',
	'timer.daysShortLower': 'd',
	'timer.hoursShortLower': 'h',
	'timer.minutesShortLower': 'm',
	'timer.secondsShortLower': 's',
	'timer.yearEnded': '🎉 Year Ended!',
	'timer.option.basic.name': 'Minimalist Single Line',
	'timer.option.basic.desc': 'Clean and simple one-line format',
	'timer.option.card.name': 'Colorful Cards',
	'timer.option.card.desc': 'Colorful cards for each time unit',
	'timer.option.clock.name': 'Digital Clock Style',
	'timer.option.clock.desc': 'Bold terminal-style digital clock',
	'timer.option.circular.name': 'Progress Ring Style',
	'timer.option.circular.desc': 'Modern circular progress indicators',
	'timer.option.flip.name': 'FlipCard Animation',
	'timer.option.flip.desc': 'Animated flip cards (desktop only)',
	'timer.option.icon.name': 'Text-Based with Icons',
	'timer.option.icon.desc': 'Emoji icons with abbreviated text',
	resolutionUpdatedSuccessfully: 'Resolution updated successfully!',
	errorUpdatingResolution: 'Error updating resolution',
	failedToUpdateResolution: 'Failed to update resolution',
	settingsUpdatedSuccessfully: 'Settings updated successfully!',
	errorDeletingResolution: 'Error deleting resolution',
	failedToDeleteResolution: 'Failed to delete resolution',
	failedToUpdateSettings: 'Failed to update settings',
	settingsSavedSuccessfully: 'Settings saved successfully!',
	failedToSaveSettings: 'Failed to save settings',
	errorSavingSettings: 'Error saving settings',
	resolutionDeletedSuccessfully: 'Resolution deleted successfully!',
	// Landing page translations
	landingHeroTitle: 'Turn Your Goals Into Momentum',
	landingHeroSubtitle:
		'resolvo.me helps you define meaningful resolutions, track progress with purpose, and transform your dreams into lasting habits.',
	landingGetStarted: 'Start Your Journey',
	landingLearnMore: 'See How It Works',
	landingAndroidComingSoon: '📱 Android app coming soon',
	landingAimTitle: 'Why resolvo.me?',
	landingAimDesc:
		'We believe in the power of clear goals and consistent tracking. resolvo.me is designed for people who want to succeed—not through perfection, but through progress.',
	// Core Missions
	landingMission1Title: 'Break the February Falloff',
	landingMission1Desc:
		"Most New Year's resolutions fail by February—not because the goals are wrong, but because we stop tracking.",
	landingMission2Title: 'Turn Intentions into Action',
	landingMission2Desc:
		"Real change doesn't come from promises alone. It comes from daily choices, weekly reflection, and seeing your progress compound over time.",
	landingMission3Title: 'Simplify the Process',
	landingMission3Desc:
		"Set your goals, log your progress, get weekly feedback, and see what actually works. That's it.",
	landingMission4Title: 'Build Lasting Capability',
	landingMission4Desc: "Lasting change isn't about perfection—it's about consistency turning into capability.",
	landingFeature1Title: 'Multiple Resolution Types',
	landingFeature1Desc: 'Choose the tracking method that fits your goal',
	landingFeature2Title: 'Track & Visualize',
	landingFeature2Desc: 'See your progress through charts, streaks, and meaningful insights',
	landingFeature3Title: 'Weekly Status Updates',
	landingFeature3Desc: 'Stay accountable with email summaries every week',
	landingFeature4Title: 'Safe & Private',
	landingFeature4Desc: 'Your data is encrypted. You own your goals.',
	landingResolutionTypesTitle: 'Resolution Types',
	landingResolutionTypesSubtitle: 'Pick the format that best fits your goal',
	landingBinaryType: 'Binary (Yes/No)',
	landingBinaryDesc: 'Simple daily check-ins for habits and routines',
	landingBinaryExample1: 'Buy a new car',
	landingBinaryExample2: 'Find a new job',
	landingCountType: 'Count',
	landingCountDesc: 'Track how many times you do something',
	landingCountExample1: 'Read 20 books this year',
	landingCountExample2: 'Write 50 blog posts this year',
	landingMetricType: 'Metric',
	landingMetricDesc: 'Track numeric progress with a start and target value',
	landingMetricExample1: 'Lose 10 kg by year-end',
	landingMetricExample2: 'Save $5,000 this year',
	landingStreakType: 'Streak',
	landingStreakDesc: 'Build consecutive days of success to amplify motivation',
	landingStreakExample1: 'Drink 2L of water every day',
	landingStreakExample2: 'Write 500 words daily for your novel',
	landingQuote1: 'Success is the product of daily habits—not once-in-a-lifetime transformations.',
	landingQuote1Author: 'James Clear',
	landingQuote2: 'The secret of getting ahead is getting started.',
	landingQuote2Author: 'Mark Twain',
	landingFeaturesTitle: 'Features Built for Success',
	landingFeatureLogging: 'One-Tap Logging',
	landingFeatureLoggingDesc: 'Log your progress in seconds, anywhere',
	landingFeatureHistory: 'Progress History',
	landingFeatureHistoryDesc: "Review all your entries and see how far you've come",
	landingFeatureReminders: 'Smart Reminders',
	landingFeatureRemindersDesc: 'Optional reminders to keep you on track',
	landingFeatureExport: 'Export Your Data',
	landingFeatureExportDesc: "Download your data anytime—it's yours",
	landingCtaTitle: 'Ready to make this your best year?',
	landingCtaDesc: 'Join thousands of people already working toward their goals.',
	landingCtaButton: 'Create Your First Resolution',
	landingFooterAbout: 'resolvo.me: Simple. Private. Built for people who actually want to change.',
	landingFooterContact: 'Questions? Contact us or visit the app',
};

export default en;
